import React, { Component } from 'react';
import { inject, observer } from 'mobx-react/index';
import { Form, Row, Col, Input, Select, Button } from 'antd';
const Option = Select.Option;

@inject('store')
@observer
export class NewSignalFormComponent extends Component {
    async handleSubmit() {
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                try {
                    await this.props.store.copyTradingStore.createSignal(values);
                    await this.props.store.copyTradingStore.getRecentSignals();
                    //  this.props.form.resetFields();
                } catch (e) {
                    alert(e.message);
                }
            }
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Row gutter={24}>
                <Col md={8}>
                    <Form.Item label="Exchange">
                        {getFieldDecorator('exchange', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(
                            <Select style={{ width: '100%' }}>
                                <Option value="bybit">ByBit</Option>
                            </Select>
                        )}
                    </Form.Item>
                </Col>

                <Col md={8}>
                    <Form.Item label="Symbol">
                        {getFieldDecorator('symbol', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(
                            <Select style={{ width: '100%' }}>
                                <Option value="BTCUSD">BTCUSD</Option>
                                <Option value="ETHUSD">ETHUSD</Option>
                            </Select>
                        )}
                    </Form.Item>
                </Col>

                <Col md={8}>
                    <Form.Item label="Direction">
                        {getFieldDecorator('side', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(
                            <Select style={{ width: '100%' }}>
                                <Option value="buy">Long</Option>
                                <Option value="sell">Short</Option>
                            </Select>
                        )}
                    </Form.Item>
                </Col>

                <Col md={8}>
                    <Form.Item label="Entry Price">
                        {getFieldDecorator('price', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(<Input />)}
                    </Form.Item>
                </Col>

                <Col md={8}>
                    <Form.Item label="Exit Price">
                        {getFieldDecorator('tp_target', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(<Input />)}
                    </Form.Item>
                </Col>

                <Col md={8}>
                    <Form.Item label="Stop Loss">
                        {getFieldDecorator('sl_target', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(<Input />)}
                    </Form.Item>
                </Col>

                <Col md={24} style={{ textAlign: 'right' }}>
                    <Button size="large" onClick={this.handleSubmit.bind(this)} type="primary">
                        Create
                    </Button>
                </Col>
            </Row>
        );
    }
}

export const NewSignalForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            data[k] = Form.createFormField({ value: props.data[k] });
        });
        return data;
    }
})(NewSignalFormComponent);



// WEBPACK FOOTER //
// ./src/Account/CopyTradingView/NewSignalForm.js